export default __webpack_public_path__ + "static/media/01.d5860c9b.png";